import {createEntityAdapter, EntityAdapter, EntityState} from "@ngrx/entity";
import {createReducer, on} from "@ngrx/store";
import {ITablePagerOptions} from "../../../../shared/shared/table/components/table-pager/ITablePagerOptions";
import {UserListItemDto} from "../dto/user-list.dto";
import {IUserWorkspace} from "./user-workspace";

import * as usersListingActions from "./users-listing.actions";

export enum HttpActionState {
    Init = 'INIT',
    Busy = 'BUSY',
    Done = 'DONE',
    Failed = 'Failed'
}

export const usersListingAdapter: EntityAdapter<UserListItemDto> = createEntityAdapter<UserListItemDto>({
    selectId: model => model.id,
});


export interface IUsersListingState {
    users: EntityState<UserListItemDto>;
    lastSelectedUserId: number | null;
    requestState: HttpActionState;
    paging?: ITablePagerOptions;
    search?: string;
    total?: number;
}


const initialState: IUsersListingState = {
    users: usersListingAdapter.getInitialState(),
    lastSelectedUserId: null,
    requestState: HttpActionState.Init,
    paging: {
        pageSize: 1,
        currentPage: 1,
        pagesCount: 1,
        total:0
    },
    search: '',
    total: 0
}
export const usersListingReducers = createReducer<IUsersListingState>(
    initialState,
    on(usersListingActions.resetState, () => ({
        ...initialState
    })),
    on(usersListingActions.fetchUsers, (state) => ({
        ...state,
        requestState: HttpActionState.Busy
    })),
    on(usersListingActions.fetchUsersSucceeded, (state, {usersList}) => ({
        ...state,
        paging: {
            currentPage: usersList.current_page || 1,
            pagesCount: usersList.last_page || 1,
            pageSize: usersList.per_page || 1,
            total: usersList.total || 0
        },
        requestState: HttpActionState.Done,
        users: usersListingAdapter.setAll(usersList.data, state.users),
        lastSelectedUser: initialState.lastSelectedUserId,
        total: usersList.total
    })),
    on(usersListingActions.fetchUsersFailed, (state) => ({
        ...state,
        requestState: HttpActionState.Done,
        paging: initialState.paging,
        users: initialState.users,
        lastSelectedUserId: initialState.lastSelectedUserId,
        total: initialState.total
    })),
    on(usersListingActions.searchChange, (state, {searchValue}) => ({
        ...state,
        search: searchValue
    })),
    on(usersListingActions.changePage, (state, {pageNumber}) => ({
        ...state,
        paging: {
            ...state.paging,
            currentPage: pageNumber
        }
    })),
    on(usersListingActions.selectedUser, (state, {userId}) => ({
        ...state,
        lastSelectedUserId: userId
    })),
    on(usersListingActions.addWorkspace, (state, {userId, workspaceId, name}) => ({
        ...state,
        users: usersListingAdapter.updateOne(
            {
                id: userId,
                changes: {
                    workspaces: addWorkspace([...state.users.entities[userId].workspaces], {
                        id: workspaceId,
                        name: name
                    })
                }
            },
            state.users)

    })),
    on(usersListingActions.removeWorkspace, (state, {userId, workspaceId}) => ({
        ...state,
        users: usersListingAdapter.updateOne({
                id: userId,
                changes: {
                    workspaces: removeWorkspace([...state.users.entities[userId].workspaces], workspaceId)
                }
            },
            state.users)
    })),
    on(usersListingActions.updateUser, (state, {userData}) => ({
        ...state,
        users: usersListingAdapter.updateOne({
            id: userData.id,
            changes: userData
        }, state.users)
    })),
    on(usersListingActions.deleteUser, (state, {userId}) => ({
        ...state,
        users: usersListingAdapter.removeOne(userId, state.users),
        lastSelectedUserId: null,
        total: state.total - 1
    })),
    on(usersListingActions.updateUserRoles, (state, {userId, roles},) => ({
        ...state,
        users: usersListingAdapter.updateOne({
                id: userId,
                changes: {
                    roles: roles
                }
            },
            state.users)
    }))
);


function addWorkspace(workspaces: IUserWorkspace[], newWorkspace: IUserWorkspace): IUserWorkspace[] {
    if (workspaces.findIndex(x => x.id === newWorkspace.id) === -1) {
        workspaces.push(newWorkspace);
    }

    return workspaces;
}

function removeWorkspace(workspaces: IUserWorkspace[], workspaceId: number): IUserWorkspace[] {
    const index = workspaces.findIndex(x => x.id === workspaceId);
    if (index > -1) {
        workspaces = workspaces.splice(index, 1);
    }

    return workspaces;
}